// extracted by mini-css-extract-plugin
export default {"row":"dTGZeTyQGRzks0sC9LIs"};